import React from 'react';

// A top-level safety net: without this, an error thrown anywhere in the
// render tree unmounts the whole app with nothing on screen (React's
// default behavior with no boundary), which is indistinguishable from a
// stuck/blank page and impossible to diagnose from a screenshot alone.
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ errorInfo });
        console.error('App crashed:', error, errorInfo);
    }

    render() {
        if (this.state.error) {
            return (
                <div style={{ padding: 24, fontFamily: 'monospace', whiteSpace: 'pre-wrap', color: '#b00020' }}>
                    <h2>Something crashed</h2>
                    <p>{String(this.state.error && this.state.error.stack ? this.state.error.stack : this.state.error)}</p>
                    {this.state.errorInfo && (
                        <>
                            <h3>Component stack</h3>
                            <p>{this.state.errorInfo.componentStack}</p>
                        </>
                    )}
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
